module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAYCAMAAAC2se+IAAAAAXNSR0IB2cksfwAAAEJQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjuH28gAAABZ0Uk5TACBfd4BAeDAIYCigr2fAtIRos6GwJxhYk7IAAAC5SURBVHicldPRDsIgDAXQApW1KtBN/f9ftTBNdGNbdx/Iwk5ueGgBWpwP2EnwDla59OScy9I6jAOtKzRDxGU347VLq0Ze3ETcskAY6nm764t8u8Ft3P5Ryrm+H9gfYkpYpH1VuI/VjoI2LGoJbVgmtWDEJav9KuYDXAjgt3IXT2dwTmTGUjCRFaOMqq0YSbVYMaiexIpVfwapZndEYz0fT7XzZJ8afofhtbFWYbVWpxZWuzn2ZOS/3jfE3QetsyYU2AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/video.png
// module id = 977
// module chunks = 0